import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton, Tooltip } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers'; 
import PageHeader from 'main/components/PageHeader';

const styles = theme => ({
    layoutRoot: {},
});

class MajorList extends Component {

    constructor(props) {
        super(props);
        this.props.getMajorList();
    }

    handleRowClick(page_type, major_id) {
        this.props.history.push(`/major/${page_type}/${major_id}`);
    }

    render() {
        const { classes, majorList, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <PageHeader
                        component_type = {"major"}
                        view_type      = {"list"}
                    />
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">
                        <TabPanelButtons
                            component_name = {"major"}
                            view_type      = {"list"}
                            button_list    = {[
                                {
                                    display: "Add",
                                    type:    "create",
                                    color:   "primary",
                                    onClick: () => this.props.history.push("/major/create"),
                                }
                            ]}
                        />
                    </div>
                }
                content={
                    <ReactTable
                        style={{ position: 'absolute' }}
                        columns={[
                            {
                                Header: "Major Name",
                                accessor: "MajorName",
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.MajorName}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Major Description",
                                accessor: "MajorDescription",
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.MajorDescription}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Actions",
                                maxWidth: 150,
                                Cell: row => (
                                    <div className="flex items-center">
                                        <Tooltip title="Detail">
                                            <IconButton
                                                style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.handleRowClick('detail', row.original.major_id);
                                                }}
                                            >
                                                <Icon>library_books</Icon>
                                            </IconButton>
                                        </Tooltip>
                                        {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "major", "edit") ? null :
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.handleRowClick('edit', row.original.major_id);
                                                    }}
                                                >
                                                    <Icon>border_color</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </div>
                                )
                            }
                        ]}
                        data={majorList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Majors Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                }
            />
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMajorList:     Actions.getMajorList,
        setTableSort:     TableActions.setTableSort,
        setTableFilter:   TableActions.setTableFilter,
        setTablePageSize: TableActions.setTablePageSize,
    }, dispatch);
}

function mapStateToProps({ majorApp, tableSort, auth }) {
    return {
        majorList:       majorApp.majors.majorList,
        table_sort:      tableSort.table_sort,
        table_filter:    tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded:       tableSort.is_loaded,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(MajorList)));


// WEBPACK FOOTER //
// src/main/content/major/MajorList.js